import { render, staticRenderFns } from "./ProductTests.vue?vue&type=template&id=1c045cd1"
import script from "./ProductTests.vue?vue&type=script&lang=ts"
export * from "./ProductTests.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports